export const eur = (n) =>
  new Intl.NumberFormat("fr-BE", { style: "currency", currency: "EUR" }).format(
    Number.isFinite(n) ? n : 0
  );

export const num = (n) =>
  new Intl.NumberFormat("fr-BE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(
    Number.isFinite(n) ? n : 0
  );

// parse a user-typed amount string (comma or dot) to a float
export const parseAmount = (s) => {
  if (s === null || s === undefined || s === "") return 0;
  const cleaned = String(s).replace(/\s/g, "").replace(",", ".").replace(/[^0-9.]/g, "");
  const v = parseFloat(cleaned);
  return Number.isFinite(v) ? v : 0;
};

const MONTHS = [
  "janv.", "févr.", "mars", "avr.", "mai", "juin",
  "juil.", "août", "sept.", "oct.", "nov.", "déc.",
];
const DAYS = ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."];

export const parseISO = (iso) => {
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d);
};

export const fmtDate = (iso) => {
  const dt = parseISO(iso);
  return `${DAYS[dt.getDay()]} ${dt.getDate()} ${MONTHS[dt.getMonth()]} ${dt.getFullYear()}`;
};

export const fmtDateShort = (iso) => {
  const dt = parseISO(iso);
  return `${String(dt.getDate()).padStart(2, "0")}/${String(dt.getMonth() + 1).padStart(2, "0")}`;
};

export const toISO = (dt) => {
  const y = dt.getFullYear();
  const m = String(dt.getMonth() + 1).padStart(2, "0");
  const d = String(dt.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};
